import { Injectable, OnInit, Output, EventEmitter } from '@angular/core';
import { STAFF } from './mock-users';
import { Http, Response, Headers, URLSearchParams, Jsonp} from '@angular/http';
import { Subject, Subscription } from 'rxjs/Rx';
import {AuthService} from "./auth.service";
import { Router } from "@angular/router";


@Injectable()
export class StaffService extends AuthService{

    private URLGetUsers = "api/v1/getManagerUsers";
    private URLUpdateUser = "api/v1/updateManagerUser";
    private URLCreateUser = "api/v1/createManagerUser";
    private URLRemoveUser = "api/v1/removeManagerUser/:id";
    private ID = ":id";
    constructor(public http: Http, public router: Router) { 
        super(http,router)
    }

    public getUsers() {
        return this.http.get(this.APIURL + this.URLGetUsers ,{headers: this.headers})
        .map((res: Response) => res.json()["data"]); 
    }

    public updateUser(data: object) {
        return this.http.post(this.APIURL + this.URLUpdateUser , data, {headers: this.headers})
        .map((res: Response) => res.json()["status"]); 
    }

    public createUser(data: object) {
        return this.http.post(this.APIURL + this.URLCreateUser , data, {headers: this.headers})
        .map((res: Response) => res.json()["data"]); 
    }

    public removeUser(id: string) {
        let URLRemoveUser = this.URLRemoveUser.replace(this.ID, id);
        return this.http.get(this.APIURL + URLRemoveUser ,{headers: this.headers})
        .map((res: Response) => res.json()["status"]); 
    }

    public canActivate() {
        
        if(this.getUserLogued()){
            var user = this.getFromLocalStorage();
            if(user["user"]["role"] == "admin"){
                return this.getUserLogued();
            }else{
                this.router.navigate(['/services']);
                return false;
            }
        }else{
            this.router.navigate(['/login']);
            return false;
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/injections/staff.service.ts